<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Base Asegurado</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
            <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Ejecutivos/Asistentes</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valEjecutivos"
                      v-model="datosFormulario.ejecutivo">
                  </b-form-select>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.ejecutivo }}</span>
              </b-col>
            </b-row>

              <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
              <b-col sm="2">
                <!-- <b-form-group> -->
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                    <!-- <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend> -->
                </b-input-group>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.poliza }}
                </span>     
                <!-- </b-form-group> -->
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Contratante</label>
              </b-col>
              <b-col sm="2">
                <b-form  @submit.prevent="consulta_contratante()" > 
                <b-input-group>
                  <b-form-input 
                      type="number" 
                      v-model="datosFormulario.contratante"
                      @change="validarCampo('contratante', 'contratante', $event, 'datosFormulario.contratante'); consulta_contratante()"/>
                  <b-input-group-prepend class="input-group-append">
                      <b-button @click="DatosContratantes()" class="fa fa-search" variant="primary"></b-button>
                  </b-input-group-prepend>
                </b-input-group>
                </b-form>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text" disabled v-model="datosFormulario.IdNacionAse"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text" disabled v-model="datosFormulario.NombreAseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group >
                    <b-form-input 
                      type="number" 
                      v-model="datosFormulario.codCorredor"
                      @change="consulta_corredor()" />
                    <b-input-group-prepend class="input-group-append">
                        <b-button @click="Datoscorredor()" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text" disabled v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text" disabled v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insercion_ConPol" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Base Asegurado</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button v-if="hasPoliza" variant="primary" @click="nuevoContacto">Agregar Contacto</b-button>
            </b-col>  
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                >
                <template slot-scope="scope">
                  <div v-if="title.prop == 'poliza'">  
                    <b-link type="text" v-if="scope.row.poliza > 0" @click="fnc_TpAvisoPol(scope.row.poliza, scope.row.tpaviso )">{{scope.row.poliza}}</b-link>
                    <p v-else >{{scope.row.poliza}}</p>
                  </div>
                  <p v-else>{{scope.row[title.prop]}}</p>
                </template>
                </el-table-column>
                
                <el-table-column label="" min-width="200px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
                
                

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      id="modificacion-contacto"
      title="Modificación Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="handleOkmod"
      @cancel="modalModificar = false"
    >
    <b-form ref="form" @submit.stop.prevent="handleSubmitmod">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Producto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.producto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Expirada</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.expirada">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Tipo de Aviso</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.tpaviso">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contratante</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcontratante">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ejecutivo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.ejecutivo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Asistente</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.asistente">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.nombrecontacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>E-mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
             invalid-feedback="La dirección de correo electrónico no incluye un signo @"
             :state="nameState">
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.mailcontacto"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

     
      <b-row class="my-1">
        <b-col sm="4">
          <label>Líneas</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.Lineas"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Prórrogas</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.prorrogas"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.fecmodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.usumodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
    
  <b-modal
      id="nuevo-contacto"
      title="Nuevo Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalNuevo"
      @ok="handleOk"
      @cancel="modalNuevo = false"
    >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Producto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.producto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Expirada</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.expirada">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Tipo de Aviso</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.tpaviso">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contratante</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcontratante">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ejecutivo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.ejecutivo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Asistente</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.asistente">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.nombrecontacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>E-mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
            invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState">
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.mailcontacto"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Líneas</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.Lineas"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
        <!-- </b-row> -->

        <!-- <b-row class="my-1"> -->
        <b-col sm="4">
          <label>Prórrogas</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.prorrogas"
                value="Si"
                unchecked-value="No">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    </b-modal>


    <!-- Eliminar -->
    <b-modal
    
      title="Eliminar Contacto"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminar_ConPol();"
      @cancel="modalEliminar = false"
    >
        Se eliminara el siguiente contacto:
        <br><br>
        Asegurado: {{datosFormularioModal.nomcontratante}} 
        <br>
        Contacto: {{datosFormularioModal.nombrecontacto}} 
        
    </b-modal>

    <b-modal
      size="lg"
      scrollable
      hide-footer
      title="Búsqueda de Contratante"
      cancel-title="Cancelar"
      v-model="modalContratante"
      @cancel="modalContratante = false"
    >
    <b-row class="my-1">
      <b-col sm="6">
        <label>Buscar:</label>
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroProceso"
            type="text"
            placeholder="Filtrar"
            v-model="filters2[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="data1"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters2"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles2"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <template slot-scope="scope">
                    <div v-if="title.prop == 'pernombreimp'">  
                        <b-link type="text" v-if="scope.row.percodigo > 0" @click="selecciona_contratante(scope.row.percodigo, scope.row.pernombreimp, scope.row.peridnacion)" >{{scope.row.pernombreimp}}</b-link>
                        <p v-else >{{scope.row.pernombreimp}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
              
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      title="Búsqueda de Corredor"
      scrollable
      cancel-title="Cerrar"
      class="modal-success"
      size="lg"
      v-model="modalCorredor"
      @cancel="modalCorredor = false"
      hide-footer
    >
      <b-row> 
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters3[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
      <b-row>
      <b-col lg="12">             
        <div ref="refTable">
          <data-tables ref="refTable1"
            :data="data2"
            name="table"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters3"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table"
            >
          <el-table-column
            v-for="title in titles3"
            :min-width="title.minwidth" 
            :prop="title.prop"
            :label='title.label'
            :key="title.label"
            :align="title.align"
            sortable="custom"
            :formatter="formatter"
            name="table"
            class="table-responsive"
            >

            <template slot-scope="scope">  
              <div v-if="title.prop == 'corredor'">    
                <b-link type="text" v-if="scope.row.codcorredor > 1" @click="selecciona_corredor(scope.row.codcorredor,scope.row.corredor,scope.row.idnacion)">{{scope.row.corredor}}</b-link>
                  <p v-else >{{scope.row.corredor}}</p>
                  </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
            </template>  

          </el-table-column>
          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>  

    <b-modal
      size="lg"
      title="Tipo de aviso de la póliza"
      cancel-title="Cancelar"
      ok-title="Aceptar"
      class="modal-success"
      v-model="modalTpAvisoPol"
      @ok="actuliza_tpaviso();"
      @cancel="modalTpAvisoPol = false"
    >

    <b-row class="my-1">
        <b-col sm="2">
          <label>Póliza</label>
        </b-col>
        <b-col sm="3">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormulario.avpoliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
       
        <b-col sm="2">
          <label style="text-aling:rigth">Tipo de Aviso</label>
        </b-col>
        <b-col sm="3">
          <b-form-select
            :options="valTpaviso"
            v-model="datosFormulario.tpaviso">
          </b-form-select>
                  
        </b-col>
    </b-row>

        
        
    </b-modal>


  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiBaseDatosResoluc from "@/components/services/apiBaseDatosResoluc";
import apiConCorredor  from "@/components/services/apiConCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      nameState: null,
      submittedNames: [],
      modalModificar : false,
      modalEliminar : false,
      modalTpAvisoPol : false,
      modalContratante : false,
      modalCorredor : false,        
      modalNuevo : false,
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      ckdDire: [
          { item:  'DL', name: 'Dirección Legal' },
          { item:  'DP', name: 'Dirección Postal' }
        ],
      ckdCorred: [
          { item: 'C', name: 'Corredor' }
        ],
      chkDireccion:false,

      data: [],
      data1: [],
      data2: [],
      nombreexcel: "BaseAsegurado",
      
      titles: [
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "expirada",
          label: "Expirada",
          align: "center",
          minwidth:'70'
        },
        {
          prop: "tpaviso",
          label: "Tipo de Aviso",
          align: "center",
          minwidth:'70'
        },
        {
          prop: "nomcontratante",
          label: "Contratante",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "ejecutivo",
          label: "Ejecutivo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "asistente",
          label: "Asistente",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "nombrecontacto",
          label: "Nombre Contacto",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "mailcontacto",
          label: "E-mail Contacto",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "lineas",
          label: "Líneas",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "prorrogas",
          label: "Prórrogas",
          align: "center",
          minwidth:'90'
        },
      ],

      titles2: [
        {
          prop: "pernombreimp",
          label: "Contratante",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "percodigo",
          label: "Código",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "peridnacion",
          label: "Id Nacional",
          align: "center",
          minwidth:'100'
        },
      ],

      titles3: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "codcorredor",
          label: "Código",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "idnacion",
          label: "Id. Nacional",
          align: "center",
          minwidth:'120'
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filters2: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filters3: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          id: "",
          poliza:"",
          producto:"",
          expirada:"",
          tpaviso:"",
          nomcontratante:"",
          ejecutivo:"",
          asistente:"",
          nombrecontacto:"",
          mailcontacto:"",
          mailcontactoold:"",
          Lineas:"",
          prorrogas:"",
          fecmodif:"",
          usumodif:""
      },
      
      mostrarFechas: true,
      datosFormulario: {
          poliza:"",
          tpaviso:"",
          producto:"",
          contratante:"",
          IdNacionAse :"",
          NombreAseg:"",
          IdNacionCorred:"",
          NombreCorred:"",
          ejecutivopol:"",
          ejecutivo:"",
          asistentepol:"",
          avpoliza:"",
          
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      valEjecutivos: [],
      valTpaviso: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {

    checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
    resetModal() {
        this.name = ''
        this.nameState = null
      },

    handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault();  
        // Trigger submit handler
        this.handleSubmit();
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        }
        // Push the name to submitted names
        this.submittedNames.push(this.datosFormularioModal)
        // Hide the modal manually
        this.$nextTick(() => {
          this.crear_ConPol();
          this.$bvModal.hide('nuevo-contacto');
        })
      },

    handleOkmod(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault();  
        // Trigger submit handler
        this.handleSubmitmod();
      },
      handleSubmitmod() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        }
        // Push the name to submitted names
        this.submittedNames.push(this.datosFormularioModal)
        // Hide the modal manually
        this.$nextTick(() => {
        this.actualizar_ConPol();
        this.$bvModal.hide('modificacion-contacto');
        })
      },  

    fnc_TpAvisoPol(p_poliza, p_tpaviso){
        this.datosFormulario.avpoliza = p_poliza;
          if (p_tpaviso == 'Externo'){
            this.datosFormulario.tpaviso= "E";
          } else if (p_tpaviso == 'Interno'){
            this.datosFormulario.tpaviso= "I";
          }
          
      this.modalTpAvisoPol = true;
    },

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificarContacto(row);
          }
          botones.push(obj);
          
          var obj2 = new Object();
          obj2.tooltip = "Eliminar";
          obj2.id = 2;
          obj2.name="Eliminar";
          obj2.icon = "fa fa-eraser";
          obj2.type = "success";
          obj2.handler= _ => {
              this.$session.start();
              this.eliminarContacto(row);
          }
          botones.push(obj2);
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    selecciona_contratante(p_codcontratante, p_nomcontratante, p_idnacional){
      this.datosFormulario.contratante = p_codcontratante;
      this.datosFormulario.IdNacionAse = p_idnacional;
      this.datosFormulario.NombreAseg = p_nomcontratante
      this.modalContratante = false;

    },

    selecciona_corredor(p_codcorredor, p_corredor, p_idnacion) {
       this.datosFormulario.codCorredor = p_codcorredor;
       this.datosFormulario.NombreCorred = p_corredor;
       this.datosFormulario.IdNacionCorred = p_idnacion;
       this.modalCorredor = false;
       
    },
    
    actuliza_tpaviso(){
      return apiBaseDatosResoluc
          .fnc_actuliza_tpaviso(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.avpoliza,
            this.datosFormulario.tpaviso
          )
          .then((response) => {
            
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha actualizado el Tipo de Aviso",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          }); 

    },
    
    pre_insercion_ConPol() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.ejecutivo ='0';
      this.datosFormulario.poliza = "";
      this.datosFormulario.producto="";
      this.datosFormulario.contratante ="";
      this.datosFormulario.IdNacionAse ="";
      this.datosFormulario.NombreAseg ="";
      this.datosFormulario.codCorredor ="";
      this.datosFormulario.NombreCorred ="";
      this.datosFormulario.IdNacionCorred ="";
      this.hasPoliza = false;

      return apiBaseDatosResoluc
        .pre_insercion_ConPol(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo ='0';
          this.datosFormulario.poliza='';
          this.datosFormulario.contratante='';
          this.datosFormulario.codCorredor='';

          
          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array(); 
          var objTodos = new Object();
          objTodos.value = "0";
          objTodos.text  = "Todos";
          tiposEjecutivos.push(objTodos); 

          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["usucodigo"];
              obj.text = lista_tipos_ejecutivos[i]["usunombre"];
              tiposEjecutivos.push(obj);
          }

          this.valEjecutivos = tiposEjecutivos;
          
          //carga de listados
          this.valTpaviso = this.llenaArrayLista(response.data.tpaviso, 'codigo', 'descripcion', false);
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      this.datosFormulario.ejecutivo == 'Todos' ? '' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.contratante == '' ? '': this.datosFormulario.contratante; 
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_ejecutivo= this.datosFormulario.ejecutivo == 'Todos' ? '0' : this.datosFormulario.ejecutivo; 
      var p_poliza = this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;
      var p_contratante = this.datosFormulario.contratante == ''? '0' : this.datosFormulario.contratante;
      var p_corredor = this.datosFormulario.codCorredor == ''? '0' : this.datosFormulario.codCorredor;

      return apiBaseDatosResoluc
      .Recuperar_ConPol(
        p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor
        ).then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      
      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      //for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Póliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Producto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Expirada" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Tipo de Aviso" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contratante" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ejecutivo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Asistente" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Mail Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Líneas" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Prórrogas" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Última Modificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Usuario" + "</td>\n";
      //}
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      
      for (var key in this.data) {
        if(this.data[key]["nombrecontacto"] === undefined){ 
          this.data[key]["nombrecontacto"] = "";
        }
        if(this.data[key]["mailcontacto"] === undefined){ 
          this.data[key]["mailcontacto"] = "";
        }
        
        if(this.data[key]["fecmodif"] == undefined){ 
          this.data[key]["fecmodif"] = "";
        }
        if(this.data[key]["usumodif"] == undefined){ 
          this.data[key]["usumodif"] = "";
        }
        if(this.data[key]["expirada"] == undefined){ 
          this.data[key]["expirada"] = "";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["expirada"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["tpaviso"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["nomcontratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asistente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["nombrecontacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["mailcontacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["lineas"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["prorrogas"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["fecmodif"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["usumodif"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
      
      this.datosFormulario.ejecutivo == 'Todos' ? '' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.contratante == '' ? '': this.datosFormulario.contratante; 
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_email= this.$session.get("mail");
      var p_ejecutivo= this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo==""){
          p_ejecutivo ='0';
      }

      return apiBaseDatosResoluc
        .consulta_poliza(
          p_email, p_ejecutivo, p_poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);
          console.log(response.data.res);
          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
            this.datosFormulario.contratante  = Listapoliza[i]["marcontratante"];
            this.datosFormulario.producto     = Listapoliza[i]["marproducto"];
            this.datosFormulario.NombreAseg   = Listapoliza[i]["nomcontratante"];
            this.datosFormulario.codCorredor  = Listapoliza[i]["marcorredor"];
            this.datosFormulario.NombreCorred = Listapoliza[i]["NomCorredor"];
            this.datosFormulario.vigente      = Listapoliza[i]["E"];
            this.datosFormulario.ejecutivopol = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.asistentepol   = Listapoliza[i]["asistente"]; 
            this.hasPoliza = true;
          }
          this.$Progress.finish();
          this.consulta_contratante();
          this.consulta_corredor();  
          this.buscar();  
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_contratante: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_contratante = this.datosFormulario.contratante == '' ? '0': this.datosFormulario.contratante; 
      var p_email = this.$session.get("mail");
      if ((p_contratante==0) || (p_contratante=="")){
          this.mensaje= "Ingrese SR Contratante";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, p_contratante
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoContratante = response.data.res;

         for (var i = 0; i < InfoContratante.length; i++) {
            this.datosFormulario.IdNacionAse = InfoContratante[i]["peridnacion"];
            this.datosFormulario.NombreAseg  = InfoContratante[i]["pernombreimp"];
            
            this.datosFormulario.asegperdireccion  = InfoContratante[i]["perdireccion"];
            this.datosFormulario.asegperciudad  = InfoContratante[i]["perciudad"];
            this.datosFormulario.asegpercomuna  = InfoContratante[i]["percomuna"];
            this.datosFormulario.asegpernacion  = InfoContratante[i]["pernacion"];
            this.datosFormulario.asegperdirpostal  = InfoContratante[i]["perdirpostal"];
            this.datosFormulario.asegperciupostal  = InfoContratante[i]["perciupostal"];
            this.datosFormulario.asegpercompostal  = InfoContratante[i]["percompostal"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_corredor: function(){
      
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.IdNacionCorred = "";
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["idnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["corredor"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    DatosContratantes: function(){
      

      var p_email = this.$session.get("mail");
      
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data1 = response.data.res;
            this.$Progress.finish();
         
          this.$Progress.finish();
          this.modalContratante = true;
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });


    },

    Datoscorredor() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      return apiConCorredor
        .consulta_corredor(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data2 = response.data.res;
            this.modalCorredor = true;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },
    

    nuevoContacto: function(){
      this.datosFormularioModal.poliza = this.datosFormulario.poliza;
      this.datosFormularioModal.producto = this.datosFormulario.producto;
      this.datosFormularioModal.expirada = this.datosFormulario.expirada == '*'? '*' : '';
      this.datosFormularioModal.tpaviso = "";
      this.datosFormularioModal.nomcontratante = this.datosFormulario.NombreAseg;
      this.datosFormularioModal.ejecutivo = this.datosFormulario.ejecutivopol;
      this.datosFormularioModal.asistente = this.datosFormulario.asistentepol;

      this.datosFormularioModal.nombrecontacto = "";
      this.datosFormularioModal.mailcontacto = "";
      this.datosFormularioModal.mailcontactoold = "";
      
      this.datosFormularioModal.Lineas = "No";
      this.datosFormularioModal.prorrogas = "No";

      this.datosFormularioModal.fecmodif = "";
      this.datosFormularioModal.usumodif = "";
      this.modalNuevo = true;
    },

    crear_ConPol() {
      
        return apiBaseDatosResoluc
          .fnc_actualizar_ConPol(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.poliza,
            this.datosFormularioModal.nombrecontacto,
            this.datosFormularioModal.mailcontactoold, 
            this.datosFormularioModal.mailcontacto, 
            this.datosFormularioModal.Lineas,
            this.datosFormularioModal.prorrogas
          )
          .then((response) => {
            
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha creado un nuevo contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      
    },

    modificarContacto: function( row ){
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.producto = row.producto;
      this.datosFormularioModal.expirada = row.expirada;
      this.datosFormularioModal.tpaviso = row.tpaviso;
      this.datosFormularioModal.nomcontratante = row.nomcontratante;
      this.datosFormularioModal.ejecutivo = row.ejecutivo;
      this.datosFormularioModal.asistente = row.asistente;
      this.datosFormularioModal.nombrecontacto = row.nombrecontacto;
      this.datosFormularioModal.mailcontacto = row.mailcontacto;
      this.datosFormularioModal.mailcontactoold = row.mailcontacto;
      this.datosFormularioModal.Lineas = row.lineas == 'Si'? 'Si' : 'No';
      this.datosFormularioModal.prorrogas = row.prorrogas == 'Si'? 'Si' : 'No';
      this.datosFormularioModal.fecmodif = row.fecmodif;
      this.datosFormularioModal.usumodif = row.usumodif;
      this.modalModificar = true;
    },

    actualizar_ConPol() {
      let rows = this.datosFormularioModal;
      
        //Modificar
        return apiBaseDatosResoluc
          .fnc_actualizar_ConPol(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.poliza,
            rows.nombrecontacto,
            this.datosFormularioModal.mailcontactoold, // old
            rows.mailcontacto, // new
            rows.Lineas,
            rows.prorrogas
          )
          .then((response) => {
            
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha actualizado contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      
    },
    
    eliminarContacto(row){
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.nomcontratante = row.nomcontratante;
      this.datosFormularioModal.nombrecontacto = row.nombrecontacto;
      this.datosFormularioModal.mailcontacto = row.mailcontacto;
      this.modalEliminar = true;
    },

    eliminar_ConPol(){
      let rows = this.datosFormularioModal;
      return apiBaseDatosResoluc
          .fnc_eliminar_ConPol(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.poliza,
            rows.nombrecontacto,
            rows.mailcontacto
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insercion_ConPol();    
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
